import SwitchTab from './SwitchTab';

export default SwitchTab;  


// WEBPACK FOOTER //
// ./src/components/SwitchTab/index.js